module.exports = __webpack_public_path__ + "static/media/coliseu_box_10.cf796784.jpg";